import { z } from 'zod'

export const tokenResponseSchema = z
  .object({
    refreshToken: z.string(),
    accessToken: z.string(),
  })
  .meta({ id: 'token-response' })
